import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';

import { PlansService } from './plans.service';
import { Plan, AppContext, SeoService } from './../shared';

@Component({
  selector: 'plans',
  template: require('./plans.component.html'),
  styles: [require('./plans.component.scss')],
  providers: [PlansService],
})
export class PlansComponent implements OnInit, AfterViewInit {
  plans: Observable<Plan[]>;

  sub: any;

  title = 'Ocean Container Shipping Schedule Plans - Linescape';
  description = 'Linescape offers various subscription plans to access liner shipping schedules, routes, ports, vessels or carrier data.';

  constructor(private service: PlansService, private route: ActivatedRoute, private router: Router, public app: AppContext, private seo: SeoService) {
  }

  ngOnInit() {
    this.seo.set(this.title, this.description);
    window.scrollTo(0, 0);
    this.getPlans();

    // no longer necessary
    // keep in case legacy links are used
    this.sub = this.route.params.subscribe(params => {
      if (params['register'] !== null && params['register'] === 'true') {
        this.openRegister('Basic');
      }

      if (params['code'] !== null && params['code'] !== undefined) {
        this.service.code = params['code'];
        this.openConfirm();
      }
    });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  getPlans() {
    this.plans = this.service.getPlans();
  }

  monthly() {
    this.service.yearlyBilling = false;
  }

  yearly() {
    this.service.yearlyBilling = true;
  }

  openRegister(planType) {
    if (!this.service.app.isLoggedIn) {
      if (planType === 'Premium') {
        this.app.signUpPlan = 'Premium';
      } else if (planType === 'Professional') {
        this.app.signUpPlan = 'Professional';
      }else if (planType === 'Enterprise') {
        this.app.signUpPlan = 'Enterprise-6';
      } else {
        this.app.signUpPlan = 'Basic';
      }

      if (this.service.yearlyBilling) {
        this.app.signUpPlanBilling = 'yearly';
      } else {
        this.app.signUpPlanBilling = 'monthly';
      }

      this.router.navigate(['/register']);
    }
  }

  openConfirm() {
    if (!this.service.app.isLoggedIn) {
      this.router.navigate(['/confirm', { code: this.service.code }]);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/plans/plans.component.ts